// extracted by mini-css-extract-plugin
export default {"quotesPages":"quotes_quotesPages__E1Y1W"};